import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FPhi } from '@facephi/selphi-widget-web';
import { FacephiService } from '../../../Services/facephi.service';
import { UserService } from '../../../Services/userservice.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-v5',
  templateUrl: './v5.component.html',
  styleUrls: ['./v5.component.scss']
})
export class V5Component implements OnInit {
 // @Output() public responseV5 = new EventEmitter<any>();

 //navegador compatible
  private videoDevices: boolean;
  private wasm: boolean;

  constructor(
    private facephiService: FacephiService, 
    private userService: UserService
  ) {}

  FPhiSelphiConstants = FPhi.Selphi;
  objectEntriesFunc = Object.entries;

  readonly FPhiCameraResolutions = {
    res480p: { title: '640x480', width: 640, height: 480 },
    res600p: { title: '800x600', width: 800, height: 600 },
    res768p: { title: '1024x768', width: 1024, height: 768 },
    res720p: { title: '1280x720 (720p)', width: 1280, height: 720 },
    res1080p: { title: '1920x1080 (1080p)', width: 1920, height: 1080 },
  };

  isWidgetCaptureStarted = false;

  widgetFaceTracking = true;
  widgetInteractible = true;
  widgetTutorial = true;
  widgetStabilizationStage = true;
  widgetVideoRecord = false;
  widgetShowLog = false;
  widgetDebugMode = false;

  widgetCameraResolution = 'res720p';
  widgetCameraType: number = this.FPhiSelphiConstants.CameraType.Front;
  widgetLivenessMode: number = FPhi.Selphi.LivenessMode.Passive;

  get widgetCameraWidth(): number { return this.FPhiCameraResolutions['res720p'].width;}
  get widgetCameraHeight(): number { return this.FPhiCameraResolutions['res720p'].height;}

  onStartCapture() { 
    if(  this.videoDevices == false || this.wasm == false ){
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: `Su navegador no es compatible`,
        confirmButtonColor: '#001b71'
      });
    }else {
      this.isWidgetCaptureStarted = true; 
    }
  }
  onStopCapture() { 
    this.isWidgetCaptureStarted = false; 
  }

  async ngOnInit() {
    const Compro = await this.FPhiSelphiConstants.CheckCapabilities();
    console.log(Compro);
    this.videoDevices = Compro['video_devices'];
    this.wasm = Compro['wasm'];
  }

  // Widget event handlers
  public onModuleLoaded(eventData:any) {
    console.warn('[Selphi] onModuleLoaded');
    console.log(eventData);
   }

   
  public onStabilizing(stabilizingResult:any) {
    console.warn('[Selphi] onStabilizing');
    console.log(stabilizingResult);
  }

  public onExtractionFinish(extractionResult:any) {
    console.warn('[Selphi] onExtractionFinish');
   /* console.log(extractionResult);

    console.log('Images returned: ', extractionResult.detail.images);
    for (let i = 0; i < extractionResult.detail.images.length; i++) {
      const img = extractionResult.detail.images[i];
      console.log(`Image ${i}: ${img.src}`);
    }
    console.log("detalles ", extractionResult.detail);*/
    console.log("IMAGE ", extractionResult.detail.bestImage);
    if (extractionResult.detail.bestImage) {

      
      
      FPhi.Selphi.Component.generateTemplateRawFromByteArray('./assets/selphi', extractionResult.detail.bestImage,
        result => {
          console.log('BestImage Template Raw: ', result);
          this.userService.getTokenFacephi().subscribe(
          (res:any)=>{
         //   console.log("IMGTOK", result)

            //const image = extractionResult.detail.bestImage.src.split(',')
            const token = res.token;
            const data = {
              tokenImage: result,
              token: token,
              templateRaw: extractionResult.detail.templateRaw,
              imgFace: extractionResult.detail.bestImage.src
            }

            //===========Onboarding==================
            console.log( "IS ONBOARDING", this.facephiService.isOnbarding['_value'] )
            if( this.facephiService.isOnbarding['_value'] ){
              this.facephiService.setImgFace(data)
            }else{
            //===========Fin Onboarding==================

            this.facephiService.setResponseLifeLP(data);
            }
          },
          (error:any)=>{
            console.log(error)
          })
        });
    }else {

      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: `No se pudo obtener las imagenes del rostro, por favor intentelo más tarde.`,
        confirmButtonColor: '#001b71'
      });

    }

    this.isWidgetCaptureStarted = false;

  }

  public onUserCancel() {
    console.warn('[Selphi] onUserCancel');
    this.isWidgetCaptureStarted = false;
  }

  public onExceptionCaptured(exceptionResult:any) {
    console.warn('[Selphi] onExceptionCaptured');
    console.log(`exceptionType: ${exceptionResult.detail.exceptionType}`);
    console.log(`exceptionMessage: ${exceptionResult.detail.message}`);
    console.log(exceptionResult);
    if( exceptionResult.detail.message == "Camera not found." || exceptionResult.detail.message == "Permission denied by system"){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: `No se pudo validar los permisos para acceder a la cámara`,
          confirmButtonColor: '#001b71'
      });
      this.isWidgetCaptureStarted = true;
    }

    this.isWidgetCaptureStarted = false;
  }

  public onLivenessError(livenessErrorResult:any) {
    console.warn('[Selphi] onLivenessError');
    console.log(livenessErrorResult);

    switch (livenessErrorResult.detail.livenessErrorType) {
      case this.FPhiSelphiConstants.LivenessDiagnostic.Unsuccess:
        console.log('[Selphi] Liveness error: Blink or movement not detected');
        break;
      case this.FPhiSelphiConstants.LivenessDiagnostic.UnsuccessLowPerformance:
        console.log('[Selphi] Liveness error: Low performance');
        break;
      case this.FPhiSelphiConstants.LivenessDiagnostic.UnsuccessGlasses:
        console.log('[Selphi] Liveness error: Glasses detected');
        break;
      case this.FPhiSelphiConstants.LivenessDiagnostic.UnsuccessLight:
        console.log('[Selphi] Liveness error: Bad lighting conditions');
        break;
      case this.FPhiSelphiConstants.LivenessDiagnostic.UnsuccessNoMovement:
        console.log('[Selphi] Liveness error: No movement');
        break;
      case this.FPhiSelphiConstants.LivenessDiagnostic.UnsuccessWrongDirection:
        console.log('[Selphi] Liveness error: Wrong direction');
        break;
      case this.FPhiSelphiConstants.LivenessDiagnostic.UnsuccessTooFar:
        console.log('[Selphi] Liveness error: Face too far');
        break;
    }
  }

  public onLivenessErrorButtonClick() {
    console.warn('[Selphi] onLivenessErrorButtonClick');
    this.isWidgetCaptureStarted = false;
  }

  public onExtractionTimeout(extractionTimeoutResult:any) {
    console.warn('[Selphi] onExtractionTimeout');
    console.log(extractionTimeoutResult);
  }

  public onTimeoutErrorButtonClick() {
    console.warn('[Selphi] onTimeoutErrorButtonClick');
    this.isWidgetCaptureStarted = false;
  }

  public onTrackStatus(eventData:any) {
    const trackStatusCode = Object.entries(this.FPhiSelphiConstants.TrackStatus).find(e => e[1] === eventData.detail.code) || '';

    console.warn(`[Selphi] onTrackStatus (Code: ${trackStatusCode[1]} - ${trackStatusCode[0]}, Timestamp: ${eventData.detail.timeStamp}`);
    console.log(eventData);
  }



}
